import { module } from 'modujs';

/**
 * Passenger Sum
 *
 * Dynamically adjust the maxinum value for multiple input number controls.
 */
export default class extends module {
    /**
     * Log standard information.
     *
     * @type {boolean}
     */
    DEBUG = false;

    /**
     * @return {HTMLInputElement[]}
     */
    get inputs() {
        return this.$('input');
    }

    /**
     * @return {HTMLInputElement[]}
     */
    get outputs() {
        return this.$('output');
    }

    /**
     * Returns the largest of the input maximum numbers.
     *
     * @return {number}
     */
    get max() {
        let max = 0;
        for (const input of this.inputs) {
            max = Math.max(max, Number.parseInt(input.max));
        }
        return max;
    }

    /**
     * Returns the sum of all input values.
     *
     * @return {number}
     */
    get sum() {
        let sum = 0;
        for (const input of this.inputs) {
            sum += input.valueAsNumber;
        }
        return sum;
    }

    /**
     * @param {object} options
     */
    constructor(options) {
        super(options);

        this.mCaptureEvents = [ 'invalid' ];

        this.events = {
            'input': {
                'input': 'handleInput',
            },
            'invalid': {
                'input': 'handleInvalid',
            },
        };
    }

    handleInput(event) {
        this.resolve(event.target);
        this.el.classList.remove('-invalid');
    }

    /**
     * Handles input validation.
     */
    handleInvalid() {
        this.el.classList.add('-invalid');
    }

    init() {
        const input = this.inputs[0];
        if (input) {
            this.resolve(input);
        }
    }

    resolve(target) {
        const min = 1;
        let max = 0, sum = 0;

        const value = target.valueAsNumber;

        const inputs = this.inputs;

        for (const input of inputs) {
            max = Math.max(max, Number.parseInt(input.max));

            if (input !== target) {
                sum += input.valueAsNumber;
                input.min = 0;
            }
        }

        const tally = (sum + value);

        if (tally > max) {
            target.value = (max - sum);
        }

        inputs[0].min = (tally < min) ? min : 0;

        const total = Math.min(tally, max);

        this.outputs.forEach((output) => {
            if (total > 1) {
                output.textContent = this.getData('many').replace('{count}', total);
            } else if (total > 0) {
                output.textContent = this.getData('one').replace('{count}', total);
            } else {
                output.textContent = this.getData('none').replace('{count}', total);
            }
        });

        this.el.dataset.passengerSumCount = total;

        this.DEBUG && console.log('[App.PassengerSum]', 'Change Input:', sum, max);
    }
}
